import { ChangeDetectionStrategy, Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { EventType, Router, RouterOutlet } from '@angular/router';
import { startWith } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoadingIndicatorComponent } from '../common/components/loading-indicator/loading-indicator.component';
import { FooterComponent } from '../core/footer/footer.component';
import { DashboardNavComponent } from './dashboard-nav/dashboard-nav.component';

@Component({
  selector: 'app-dashboard',
  imports: [
    RouterOutlet,
    DashboardNavComponent,
    FooterComponent,
    LoadingIndicatorComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent {
  constructor(
    private _router: Router,
  ) {
  }

  protected isRouteLoading = toSignal(this._router.events
    .pipe(
      startWith(true),
      map((_: any) => _.type === EventType.NavigationStart),
    ));
}
